import React from "react";
import ReactMarkdown from "react-markdown";

import ContentWrapper from "../components/ContentWrapper";
import SubPage from "../components/SubPage";
import pageData from "../data/faq.yaml";
import * as styles from "../styles/FAQ.module.css";
import { SEO } from "../components/SEO";

interface Question {
  question: string;
  answer: string;
}

const Question = ({ question }: { question: Question }) => {
  return (
    <div className={styles.question_container}>
      <h2>{question.question}</h2>
      <ReactMarkdown>{question.answer}</ReactMarkdown>
    </div>
  );
};

export default () => {
  const meta = pageData.seo_tags;
  return (
    <SubPage top={true}>
      <SEO title={meta.title} image={meta.image} description={meta.description}/>
      <ContentWrapper>
        <div className={styles.heading}>
          <h1>{pageData.title}</h1>
          <p>{pageData.desc}</p>
        </div>

        {pageData.questions.map((x: any, i: number) => (
          <div key={`q_section_${i}`} className={styles.questions_container}>
            <h1>{x.title}</h1>
            {x.items.map((q: Question, index: number) => {
              return <Question key={`question_${index}`} question={q} />;
            })}
          </div>
        ))}
      </ContentWrapper>
    </SubPage>
  );
};
